import Rating, { RatingProps, ratingClasses } from '@glass/web/components/base/Rating';
import makeStyles from '@glass/web/modules/theme/makeStyles';

const useStyles = makeStyles()((theme) => ({
  root: {
    [`& .${ratingClasses.iconFilled}`]: {
      color: theme.palette.secondary.main,
    },
  },
}));

type RatingComponentProps = Pick<RatingProps, 'value' | 'size' | 'precision' | 'className' | 'max'>;

const removingInteger = (num: number) => num - Math.floor(num);

function RatingComponent({
  value = 4.5,
  size,
  precision = 0.5,
  className,
  max = 5,
}: RatingComponentProps) {
  const { classes, cx } = useStyles();

  return (
    <Rating
      className={cx(classes.root, className)}
      name="rating"
      value={removingInteger(value!) > 0 ? value : Math.floor(value!)}
      size={size}
      max={max}
      precision={precision}
      readOnly
    />
  );
}

export default RatingComponent;
